import React from 'react';
import {
  InfoBlockWrapper,
  Title,
  Subtitle,
  FeaturesList,
  FeatureItem,
  FeatureIcon,
  MoreButton,
  InfoBlockInner
} from './styled';
import type { InfoBlockProps } from '../../types';
import { useClient } from '../../../../hooks/useClient';
import { makeDataStat } from '../../helpers';

const InfoBlock: React.FC<InfoBlockProps> = ({
  title,
  subtitle,
  featuresLeft,
  featuresRight,
  url,
  moreLabel
}) => {
  const isClient = useClient();

  return (
    <InfoBlockWrapper>
      <InfoBlockInner>
        <Title data-cy="adv-info-title">{title}</Title>
        {isClient && (
          <>
            <Subtitle data-cy="adv-info-subtitle">{subtitle}</Subtitle>
            <FeaturesList data-cy="adv-features-list">
              <div>
                {featuresLeft.map((f, idx) => (
                  <FeatureItem key={f.name + idx}>
                    <FeatureIcon $type={f.type} $iconUrl={f.iconUrl} /> {f.name}
                  </FeatureItem>
                ))}
              </div>
              <div>
                {featuresRight.map((f, idx) => (
                  <FeatureItem key={f.name + idx}>
                    <FeatureIcon $iconUrl={f.iconUrl} />
                    {f.name}
                  </FeatureItem>
                ))}
              </div>
            </FeaturesList>
          </>
        )}
      </InfoBlockInner>
      {url && (
        <MoreButton
          href={url}
          target="_blank"
          rel="noopener noreferrer"
          data-cy="adv-info-more-btn"
          data-stat={`${makeDataStat(title)}-advantage`}
        >
          {moreLabel}
        </MoreButton>
      )}
    </InfoBlockWrapper>
  );
};

export default InfoBlock;
